import { render, staticRenderFns } from "./BulkInventoryItems.vue?vue&type=template&id=4e965d8e&scoped=true"
import script from "./BulkInventoryItems.vue?vue&type=script&lang=ts"
export * from "./BulkInventoryItems.vue?vue&type=script&lang=ts"
import style0 from "./BulkInventoryItems.vue?vue&type=style&index=0&id=4e965d8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e965d8e",
  null
  
)

export default component.exports